import React from "react";
import PropTypes from "prop-types";

import registrationStep from "../../registrationStep";
import RegistrationCard from "../RegistrationCard";
import { Button, CardActions, CardText } from "react-md";

const Complete = ({ onSubmit }) => (
  <RegistrationCard
    title="Ready to go?"
    subtitle="That's all the information we need."
  >
    <CardText>

      <p>
        Once submitted, we'll generate release forms and email them to you for your records.
      </p>
      <p>
        Please press the complete button below, and one of our staff will call your name soon.
      </p>
      <p>Thanks!</p>
    </CardText>
    <CardActions>
      <Button
        raised
        label="Complete Registration"
        className="md-cell--right"
        primary
        onClick={() =>
          onSubmit({
            step: null,
            completed: true
          })}
      />
    </CardActions>
  </RegistrationCard>
);

Complete.propTypes = {
  onSubmit: PropTypes.func.isRequired
};
Complete.defaultProps = {};

export default registrationStep(Complete, "complete");



// WEBPACK FOOTER //
// ./src/registration/components/Complete/Complete.jsx